module.exports = __webpack_public_path__ + "static/media/HomeServiceFroward1Arrow.239f5bba.svg";